import React from "react"
import { alpha, Box } from "@mui/material"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"


export default function BITableCell(
	{
		price,
		evolutionChange,
		evolutionDiff,
		noResult,
		isCheapest,
		isMoreExpensive,
		prevPrice
	}) {
	const evolutionIcons = {
		increase: { color: dsColorNew.successText, icon: "arrow-up" },
		decrease: { color: dsColorNew.dangerRed, icon: "arrow-down" },
		equal: { icon: "equals" },
	}

	let backgroundColor = ''
	if (isCheapest) backgroundColor = dsColorNew.successText
	else if (isMoreExpensive) backgroundColor = dsColorNew.dangerRed
	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-around",
				borderRadius: "8px",
				// thin border and a light fill of the meaning colour, as the analyzers; no result dashed
				border: !noResult ? '1px solid' : `1px dashed ${dsColorNew.grayBorder}`,
				width: 120,
				minHeight: 45,
				borderColor: !noResult ? (backgroundColor ? alpha(backgroundColor, 0.45) : dsColorNew.grayBorder) : dsColorNew.grayBorder,
				backgroundColor: backgroundColor ? alpha(backgroundColor, 0.08) : dsColorNew.white,
				userSelect: "none",
			}}
		>
			<Box sx={{ py: 0.5, px: 1, width: '100%', textAlign: 'center' }}>
				<TooltipSeeker title="Current Price">
					<Box sx={{ fontSize: 15, fontWeight: 700, color: noResult ? dsColorNew.textSubtle : dsColorNew.textTitle }}>
						{!!price ? `${price}` : 'N/A'}
					</Box>
				</TooltipSeeker>
				{!noResult && (!!prevPrice || !!evolutionChange) && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
					{!!prevPrice && <TooltipSeeker title="Previous Price">
						<Box sx={{ fontSize: 11, color: dsColorNew.textMuted }}>{prevPrice}</Box>
					</TooltipSeeker>}
					{!!evolutionChange && <TooltipSeeker title="Difference between current price and previous price" componentsProps={{ sx: { display: "flex" } }}>
						<Box sx={{ display: "flex", alignItems: "center", gap: .25, color: evolutionIcons[evolutionChange]?.color ?? dsColorNew.textMuted }}>
							<IconSeeker {...evolutionIcons[evolutionChange]} sx={{ fontSize: 10 }}/>
							<Box sx={{ fontSize: 11 }}>{evolutionDiff}%</Box>
						</Box>
					</TooltipSeeker>}
				</Box>}
			</Box>
		</Box>
	</Box>
}